import { IOptionItem, ScalarType } from '@wyz/types';

type LabelFunctionFormatter<T> = (item: T) => string;
type ValueFunctionFormatter<T> = (item: T) => string | number;

/* eslint-disable @typescript-eslint/no-explicit-any */
export const mapIntoOptionItem = <
  TOptionValue extends ScalarType,
  T,
  TLabelField extends keyof T | LabelFunctionFormatter<T>,
  TValueField extends keyof T | ValueFunctionFormatter<T>,
>(
  array: T[],
  labelField: TLabelField,
  valueField: TValueField,
  additionalFields?: (item: T) => Record<string, unknown>,
): Array<IOptionItem<TOptionValue>> => {
  return array.map((item) => {
    const label: any =
      labelField instanceof Function
        ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
          (labelField as LabelFunctionFormatter<T>)(item)
        : item[labelField as keyof T];

    const value: any =
      valueField instanceof Function
        ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
          (valueField as ValueFunctionFormatter<T>)(item)
        : item[valueField as keyof T];

    return {
      label: label?.toString(),
      value: typeof value === 'number' ? value : value?.toString(),
      ...additionalFields?.(item),
    };
  });
};

type ObjectKey = string | number | symbol;
export const mapArrayToObject = <
  T,
  TKey extends ObjectKey & keyof T,
  TValue extends ObjectKey & T[TKey],
>(
  array: T[],
  key: TKey,
): Record<TValue, T> => {
  return array.reduce(
    (acc, item) => {
      const itemKey = item[key];
      acc[itemKey as TValue] = item;
      return acc;
    },
    {} as Record<TValue, T>,
  );
};
